import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import moment from 'moment';

import { registerLocale } from 'react-datepicker';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { ru } from 'date-fns/locale';

import { useTheme } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Badge from '@material-ui/core/Badge';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import Divider from '@material-ui/core/Divider';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Paper from '@material-ui/core/Paper';
import Skeleton from '@material-ui/lab/Skeleton';
import Typography from '@material-ui/core/Typography';

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';
import SearchIcon from '@material-ui/icons/Search';
import ClearIcon from '@material-ui/icons/Clear';

import * as math from '_core/utils/math';
import * as search from '_core/utils/search';
import * as api from '_core/utils/api';
import { CalendarInput } from '_core/components/CalendarInput';


const DATE_DISPLAY_FORMAT = 'D MMMM YYYY';
const DATE_INPUT_FORMAT = 'D MMMM';
const DATE_API_FORMAT = 'MM-DD';
const DATE_EXPORT_FORMAT = 'YYYY-MM-DD';

const DATE_HIGHLIGHT_DAYS = 7; // 7 days


registerLocale('ru', ru);


export const BirthdayValue = React.memo((props) => {
  const {
    l,
    classes,
    
    column,
    data
  } = props;
  
  
  const value = math.getField(data, column.nameSplit[0]);
  
  if (value === undefined)
    return '-';
  
  const dataValue = moment(value).format(DATE_DISPLAY_FORMAT);
  
  const moment1 = moment().startOf('day');
  const moment2 = moment(value).startOf('day').year(moment1.year());
  
  let days = moment1.diff(moment2, 'days');
  
  if (days < 0) {
    moment1.add(1, 'year');
    
    days = moment1.diff(moment2, 'days');
  }
  
  if (days >= 0 && days <= DATE_HIGHLIGHT_DAYS) {
    return (
      <div className={clsx(classes.statusChip, days ? 'text-orange' : 'text-red')}>
        <div>{dataValue}</div>
      </div>
    );
  } else {
    return dataValue;
  }
});

export const BirthdayFilter = React.memo((props) => {
  const {
    langInfo,
    l,
    classes,
    
    filterValue,
    setFilterValue,
    
    filterApply,
    filterReset
  } = props;
  
  
  return (
    <>
      <Divider />
      
      <ListItem className={classes.filterInputFromToDate}>
        <div>
          <OutlinedInput
            className={classes.filterInput}
            fullWidth
            readOnly
            margin="none"
            value={filterValue?.from ? moment(filterValue.from).format(DATE_INPUT_FORMAT) : ''}
            startAdornment={l('$global.field.period.from')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  disabled={!filterValue?.from}
                  onClick={() => setFilterValue((state) => ({ from: null, to: state?.to || null }))}
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            }
          />
          
          <DatePicker
            locale={langInfo?.code}
            selected={filterValue?.from || null}
            onChange={(value) => setFilterValue((state) => ({ from: value, to: state?.to || null }))}
            inline
          />
        </div>
        
        <div>
          <OutlinedInput
            className={classes.filterInput}
            fullWidth
            readOnly
            margin="none"
            value={filterValue?.to ? moment(filterValue.to).format(DATE_INPUT_FORMAT) : ''}
            startAdornment={l('$global.field.period.to')}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  edge="end"
                  disabled={!filterValue?.to}
                  onClick={() => setFilterValue((state) => ({ from: state?.from || null, to: null }))}
                >
                  <ClearIcon />
                </IconButton>
              </InputAdornment>
            }
          />
          
          <DatePicker
            locale={langInfo?.code}
            selected={filterValue?.to || null}
            onChange={(value) => setFilterValue((state) => ({ from: state?.from || null, to: value }))}
            inline
          />
        </div>
      </ListItem>
    </>
  );
});

export const BirthdayTags = React.memo((props) => {
  const {
    l,
    classes,
    
    filterApply,
    column,
    value
  } = props;
  
  
  return (
    <>
      {Number.isFinite(value.from) ? (
        <div className={classes.statusChip}>
          {l('$global.field.period.from')}
          &nbsp;
          {moment(value.from).format(DATE_INPUT_FORMAT)}
          
          <a href="" onClick={(event) => { event.preventDefault(); filterApply({ from: '', to: value.to }); }}><ClearIcon /></a>
        </div>
      ) : null}
      
      {Number.isFinite(value.to) ? (
        <div className={classes.statusChip}>
          {l('$global.field.period.to')}
          &nbsp;
          {moment(value.to).format(DATE_INPUT_FORMAT)}
          
          <a href="" onClick={(event) => { event.preventDefault(); filterApply({ from: value.from, to: '' }); }}><ClearIcon /></a>
        </div>
      ) : null}
    </>
  );
});

export const getBirthdayApiParam = (column, value) => {
  const from = !math.isEmpty(value.from) ? Number(value.from) : '';
  const to = !math.isEmpty(value.to) ? Number(value.to) : '';
  
  if (!Number.isFinite(from) && !Number.isFinite(to))
    return;
  
  return (Number.isFinite(from) ? moment(from).format(DATE_API_FORMAT) : '')
    + ':' + (Number.isFinite(to) ? moment(to).format(DATE_API_FORMAT) : '');
};

export const getBirthdayExportValue = async (props, column, data) => {
  const value = math.getField(data, column.nameSplit[0]);
  
  if (value === undefined)
    return '-';
  
  return moment(value).format(DATE_EXPORT_FORMAT);
};
